import { Button } from "@/components/ui/button.tsx";
import { Menubar } from "@/components/ui/menubar.tsx";
import { useAuth } from "@/context/auth/AuthContext";
import { openPublicSiteWithBypass } from "@/lib/cms/open-public-site-with-bypass";
import { ArrowUpRight, EyeIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

const HeaderCMS = () => {
  const { instance, instanceData } = useAuth();
  const { t } = useTranslation();

  const handleSeeSite = () => {
    void openPublicSiteWithBypass(instanceData?.frontUrl ?? "");
  };

  return (
    <Menubar className="sticky top-0 z-50 w-full h-fit px-6 py-2 bg-white border-b border-slate-300 justify-center items-center inline-flex">
      <NavLink
        to={"/dashboard"}
        className="text-[#005d8d] absolute left-[20px] text-sm font-semibold font-['Raleway'] leading-normal"
      >
        {t("exitLabel")}
      </NavLink>
      <div className="flex-col justify-center items-center gap-2 inline-flex">
        <div className="flex-col justify-center items-center flex">
          <p className="text-[#090909]/80 text-[9.45px] font-bold font-['Instrument Sans'] uppercase leading-[10.39px]">
            {t("catalogueRaisonneLabel")}
          </p>
          <p className="text-[#090909] text-[18.89px] font-medium font-['Instrument Sans'] leading-tight">
            {instance}
          </p>
        </div>
      </div>
      <div className="justify-start items-center gap-4 flex absolute right-[20px]">
        <Button
          onClick={handleSeeSite}
          className="px-3 cursor-pointer py-2 bg-white rounded-lg border border-slate-300 justify-center items-center gap-1 flex shadow-none"
        >
          <EyeIcon className="w-5 h-5 text-slate-800" />
          <div className="px-0.5 justify-center items-center flex">
            <div className="text-slate-800 text-sm font-semibold font-['Raleway'] leading-normal">
              {t("seeSiteLabel")}
            </div>
          </div>
          <ArrowUpRight className="w-5 h-5 text-slate-800" />
        </Button>
      </div>
    </Menubar>
  );
};

export default HeaderCMS;
